import {Modal, Popover} from 'bootstrap'
import AddToCartWithQuantityButton from "@/modules/front/AddToCartWithQuantityButton";
import ReactDOM from 'react-dom/client';
import React from 'react';
// UI for front
console.log('Front');

const el = document.getElementsByClassName('show-md');
if (window.innerWidth > 768) {
	for (let i = 0; i < el.length; i++) {
		el[i].classList.add('show');
	}
}

var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
	return new Popover(popoverTriggerEl)
})


// Modal
const modalEl = document.getElementById('alertModal');
let modal = null;
if (modalEl) {
	modal = new Modal(modalEl)
	console.log(modalEl.getAttribute('data-show'));
	if (modalEl && modalEl.getAttribute('data-show') === 'true') {

		modal.show()
	}
}

const dismissModalAndSetCookie = () => {
	if (modal) {
		modal.hide();
		document.cookie = "modalDismissed=true;max-age=300";
	}
}

function replaceAllAddToCart() {
	const els = document.getElementsByClassName('component-add-to-cart');
	for (let i = 0; i < els.length; i++) {
		const productId = els[i].getAttribute('data-product-id');
		const unit = els[i].getAttribute('data-unit');

		const onChange = els[i].getAttribute('data-on-change');
		const dateFrom = els[i].getAttribute('data-date-from');
		const dateTo = els[i].getAttribute('data-date-to');
		const availableQuantity = els[i].getAttribute('data-available-quantity');
		const root = ReactDOM.createRoot(els[i]);
		root.render(<AddToCartWithQuantityButton productId={productId} onChange={onChange} unit={unit}
												 dateFrom={dateFrom} dateTo={dateTo}
												 availableQuantity={availableQuantity}
												 root={root}></AddToCartWithQuantityButton>);
	}
}

replaceAllAddToCart();

window.dismissModalAndSetCookie = dismissModalAndSetCookie;